import classNames from 'classnames';

interface OwnProps {
  isFavorite: boolean;
}

const FavoriteIcon = ({ isFavorite }: OwnProps) => {
  return (
    <svg
      className={classNames(
        { 'text-white': !isFavorite },
        {
          'text-red-2': isFavorite
        }
      )}
      data-favorited={isFavorite}
      data-qa="favorite-icon"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.42871 2.44197L2.42886 2.44182C3.35213 1.50865 4.57103 1 5.87406 1C7.16314 1 8.37481 1.50063 9.29245 2.41689L9.998 3.12138L10.7046 2.41792C12.6085 0.522407 15.6799 0.529965 17.5703 2.44067L17.5705 2.44084C19.4731 4.36311 19.4764 7.49343 17.581 9.41875L9.99287 16.6208L2.41869 9.42154C0.523469 7.49358 0.527411 4.36284 2.42871 2.44197Z"
        fill="currentColor"
        stroke={isFavorite ? 'currentColor' : '#00619E'}
        strokeWidth="2"
      />
    </svg>
  );
};

export default FavoriteIcon;
